module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAgAQMAAABuGmlfAAAAA1BMVEUClUNHHYfBAAAAC0lEQVQI12MY5gAAAOAAAR8Cr9MAAAAASUVORK5CYII="